import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    children?: any;
    headerText?: string;
    isOpen?: boolean;
    width?: string | number;
    alignRight?: boolean;
    className?: string;
    onClose?: () => void;
}

export class Flyout extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        isOpen: false,
        width: 780,
        alignRight: false
    };

    render()
    {
        if (!this.props.isOpen)
            return null;

        return (
            <div className={this.props.className}>
                <div
                    className="flyout-overlay"
                    onClick={this.props.onClose}></div>
                <div
                    className={`flyout ${this.props.alignRight ? "flyout--right" : "flyout--left"}`}
                    style={{
                        width: this.props.width
                    }}>
                    <span className="flyout_header-text">{this.props.headerText}</span>
                    <i className="flyout_close-btn mdi mdi-close mdi-18px" onClick={this.props.onClose}></i>
                    <div className="flyout_container">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}